module.exports = [
	{
		"Name": "Android - Harmony",
		"IconName": "android",
		"IsOpen": false,
		"Branch": [
			{
				"Name": "Master",
				"Header": "Android-Harmony / Master",
				"Prefix": "harmony/android/master/",
				"ChangeLogUrl": "http://mobbuilds.idc.logitech.com:8080/job/Harmony/changes",
				"AppName": "Harmony.apk",
				"BucketUrl": "https://builds.myharmony.com/",
				"Template": "Android"
			},
			{
				"Name": "v5.7",
				"Header": "Android-Harmony / v5.7",
				"Prefix": "harmony/android/5.7/",
				"ChangeLogUrl": "http://mobbuilds.idc.logitech.com:8080/job/Harmony-5.7/changes",
				"AppName": "Harmony.apk",
				"BucketUrl": "https://builds.myharmony.com/",
				"Template": "Android"
			},
			{
				"Name": "v5.6",
				"Header": "Android-Harmony / v5.6",
				"Prefix": "harmony/android/5.6/",
				"ChangeLogUrl": "http://mobbuilds.idc.logitech.com:8080/job/Harmony-5.6/changes",
				"AppName": "Harmony.apk",
				"BucketUrl": "https://builds.myharmony.com/",
				"Template": "Android"
			},
			{
				"Name": "v5.5",
				"Header": "Android-Harmony / v5.5",
				"Prefix": "harmony/android/5.5/",
				"ChangeLogUrl": "http://mobbuilds.idc.logitech.com:8080/job/Harmony-5.5/changes",
				"AppName": "Harmony.apk",
				"BucketUrl": "https://builds.myharmony.com/",
				"Template": "Android"
			},
			{
				"Name": "v5.4",
				"Header": "Android-Harmony / v5.4",
				"Prefix": "harmony/android/5.4/",
				"ChangeLogUrl": "http://mobbuilds.idc.logitech.com:8080/job/Harmony-5.4/changes",
				"AppName": "Harmony.apk",
				"BucketUrl": "https://builds.myharmony.com/",
				"Template": "Android"
			},
			{
				"Name": "v5.3",
				"Header": "Android-Harmony / v5.3",
				"Prefix": "harmony/android/5.3/",
				"ChangeLogUrl": "http://mobbuilds.idc.logitech.com:8080/job/Harmony-5.3/changes",
				"AppName": "Harmony.apk",
				"BucketUrl": "https://builds.myharmony.com/",
				"Template": "Android"
			},
			{
				"Name": "v5.2",
				"Header": "Android-Harmony / v5.2",
				"Prefix": "harmony/android/5.2/",
				"ChangeLogUrl": "http://mobbuilds.idc.logitech.com:8080/job/Harmony-5.2/changes",
				"AppName": "Harmony.apk",
				"BucketUrl": "https://builds.myharmony.com/",
				"Template": "Android"
			},
			{
				"Name": "v5.1",
				"Header": "Android-Harmony / v5.1",
				"Prefix": "harmony/android/5.1/",
				"ChangeLogUrl": "http://mobbuilds.idc.logitech.com:8080/job/Harmony-5.1/changes",
				"AppName": "Harmony.apk",
				"BucketUrl": "https://builds.myharmony.com/",
				"Template": "Android"
			},
			{
				"Name": "v5.0",
				"Header": "Android-Harmony / v5.0",
				"Prefix": "harmony/android/5.0/",
				"ChangeLogUrl": "http://mobbuilds.idc.logitech.com:8080/job/Harmony-5.0/changes",
				"AppName": "Harmony.apk",
				"BucketUrl": "https://builds.myharmony.com/",
				"Template": "Android"
			},
			{
				"Name": "v5.0.1",
				"Header": "Android-Harmony / v5.0.1",
				"Prefix": "harmony/android/5.0.1/",
				"ChangeLogUrl": "http://mobbuilds.idc.logitech.com:8080/job/Harmony-5.0/changes",
				"AppName": "Harmony.apk",
				"BucketUrl": "https://builds.myharmony.com/",
				"Template": "Android"
			},
			{
				"Name": "v4.7",
				"Header": "Android-Harmony / v4.7",
				"Prefix": "harmony/android/4.7/",
				"ChangeLogUrl": "http://mobbuilds.idc.logitech.com:8080/job/Harmony-4.7/changes",
				"AppName": "Harmony.apk",
				"BucketUrl": "https://builds.myharmony.com/",
				"Template": "Android"
			},
			{
				"Name": "v4.6",
				"Header": "Android-Harmony / v4.6",
				"Prefix": "harmony/android/4.6/",
				"ChangeLogUrl": "http://mobbuilds.idc.logitech.com:8080/job/Harmony-4.6/changes",
				"AppName": "Harmony.apk",
				"BucketUrl": "https://builds.myharmony.com/",
				"Template": "Android"
			},
			{
				"Name": "v4.5",
				"Header": "Android-Harmony / v4.5",
				"Prefix": "harmony/android/4.5/",
				"ChangeLogUrl": "http://mobbuilds.idc.logitech.com:8080/job/Harmony-4.5/changes",
				"AppName": "Harmony.apk",
				"BucketUrl": "https://builds.myharmony.com/",
				"Template": "Android"
			},
			{
				"Name": "v4.4",
				"Header": "Android-Harmony / v4.4",
				"Prefix": "harmony/android/4.4/",
				"ChangeLogUrl": "http://mobbuilds.idc.logitech.com:8080/job/Harmony-4.4/changes",
				"AppName": "Harmony.apk",
				"BucketUrl": "https://builds.myharmony.com/",
				"Template": "Android"
			},
			{
				"Name": "v4.3.1",
				"Header": "Android-Harmony / v4.3.1",
				"Prefix": "harmony/android/4.3.1/",
				"ChangeLogUrl": "http://mobbuilds.idc.logitech.com:8080/job/Harmony-4.3.1/changes",
				"AppName": "Harmony.apk",
				"BucketUrl": "https://builds.myharmony.com/",
				"Template": "Android"
			},
			{
				"Name": "v4.2",
				"Header": "Android-Harmony / v4.2",
				"Prefix": "harmony/android/4.2/",
				"ChangeLogUrl": "http://mobbuilds.idc.logitech.com:8080/job/Harmony-4.2/changes",
				"AppName": "Harmony.apk",
				"BucketUrl": "https://builds.myharmony.com/",
				"Template": "Android"
			},
			{
				"Name": "v4.1",
				"Header": "Android-Harmony / v4.1",
				"Prefix": "harmony/android/4.1/",
				"ChangeLogUrl": "http://mobbuilds.idc.logitech.com:8080/job/Harmony-4.1/changes",
				"AppName": "Harmony.apk",
				"BucketUrl": "https://builds.myharmony.com/",
				"Template": "Android"
			}
		]
	},
	{
		"Name": "Android - Brownie",
		"IconName": "android",
		"IsOpen": false,
		"Branch": [
			{
				"Name": "Master",
				"Header": "Android-Brownie / Master",
				"Prefix": "brownie/android/Brownie1.0/",
				"ChangeLogUrl": "http://mobbuilds.idc.logitech.com:8080/job/Brownie-master/changes",
				"AppName": "Brownie.apk",
				"BucketUrl": "https://builds.myharmony.com/",
				"Template": "Android"
			},
			{
				"Name": "v1.5",
				"Header": "Android-Brownie / v1.5",
				"Prefix": "brownie/android/Brownie1.5/",
				"ChangeLogUrl": "http://mobbuilds.idc.logitech.com:8080/job/Brownie_1.5/changes",
				"AppName": "Brownie.apk",
				"BucketUrl": "https://builds.myharmony.com/",
				"Template": "Android"
			},
			{
				"Name": "v1.4",
				"Header": "Android-Brownie / v1.4",
				"Prefix": "brownie/android/Brownie1.4/",
				"ChangeLogUrl": "http://mobbuilds.idc.logitech.com:8080/job/Brownie_1.4/changes",
				"AppName": "Brownie.apk",
				"BucketUrl": "https://builds.myharmony.com/",
				"Template": "Android"
			},
			{
				"Name": "v1.3",
				"Header": "Android-Brownie / v1.3",
				"Prefix": "brownie/android/Brownie1.3/",
				"ChangeLogUrl": "http://mobbuilds.idc.logitech.com:8080/job/Brownie_1.3/changes",
				"AppName": "Brownie.apk",
				"BucketUrl": "https://builds.myharmony.com/",
				"Template": "Android"
			},
			{
				"Name": "v1.2",
				"Header": "Android-Brownie / v1.2",
				"Prefix": "brownie/android/Brownie1.2/",
				"ChangeLogUrl": "http://mobbuilds.idc.logitech.com:8080/job/Brownie_1.2/changes",
				"AppName": "Brownie.apk",
				"BucketUrl": "https://builds.myharmony.com/",
				"Template": "Android"
			},
			{
				"Name": "v1.1",
				"Header": "Android-Brownie / v1.1",
				"Prefix": "brownie/android/Brownie1.1/",
				"ChangeLogUrl": "http://mobbuilds.idc.logitech.com:8080/job/Brownie_1.1/changes",
				"AppName": "Brownie.apk",
				"BucketUrl": "https://builds.myharmony.com/",
				"Template": "Android"
			}
		]
	},
	{
		"Name": "iOS - Harmony",
		"IconName": "phone_iphone",
		"IsOpen": false,
		"Branch": [
			{
				"Name": "Master",
				"Header": "iOS-Harmony / Master",
				"Prefix": "harmony/iOS/master/",
				"ChangeLogUrl": "http://iosbuilds.idc.logitech.com:8080/job/Harmony-master/changes",
				"AppName": "Harmony.ipa",
				"PlistName": "Harmony.plist",
				"BucketUrl": "https://builds.myharmony.com/",
				"iOSInstallUrl": "itms-services://?action=download-manifest&url=",
				"Template": "iOS"
			},
			{
				"Name": "v5.7",
				"Header": "iOS-Harmony / v5.7",
				"Prefix": "harmony/iOS/5.7/",
				"ChangeLogUrl": "http://iosbuilds.idc.logitech.com:8080/job/Harmony-5.7/changes",
				"AppName": "Harmony.ipa",
				"PlistName": "Harmony.plist",
				"BucketUrl": "https://builds.myharmony.com/",
				"iOSInstallUrl": "itms-services://?action=download-manifest&url=",
				"Template": "iOS"
			},
			{
				"Name": "v5.6",
				"Header": "iOS-Harmony / v5.6",
				"Prefix": "harmony/iOS/5.6/",
				"ChangeLogUrl": "http://iosbuilds.idc.logitech.com:8080/job/Harmony-5.6/changes",
				"AppName": "Harmony.ipa",
				"PlistName": "Harmony.plist",
				"BucketUrl": "https://builds.myharmony.com/",
				"iOSInstallUrl": "itms-services://?action=download-manifest&url=",
				"Template": "iOS"
			},
			{
				"Name": "v5.5",
				"Header": "iOS-Harmony / v5.5",
				"Prefix": "harmony/iOS/5.5/",
				"ChangeLogUrl": "http://iosbuilds.idc.logitech.com:8080/job/Harmony-5.5/changes",
				"AppName": "Harmony.ipa",
				"PlistName": "Harmony.plist",
				"BucketUrl": "https://builds.myharmony.com/",
				"iOSInstallUrl": "itms-services://?action=download-manifest&url=",
				"Template": "iOS"
			},
			{
				"Name": "v5.4",
				"Header": "iOS-Harmony / v5.4",
				"Prefix": "harmony/iOS/5.4/",
				"ChangeLogUrl": "http://iosbuilds.idc.logitech.com:8080/job/Harmony-5.4/changes",
				"AppName": "Harmony.ipa",
				"PlistName": "Harmony.plist",
				"BucketUrl": "https://builds.myharmony.com/",
				"iOSInstallUrl": "itms-services://?action=download-manifest&url=",
				"Template": "iOS"
			},
			{
				"Name": "v5.3",
				"Header": "iOS-Harmony / v5.3",
				"Prefix": "harmony/iOS/5.3/",
				"ChangeLogUrl": "http://iosbuilds.idc.logitech.com:8080/job/Harmony-5.3/changes",
				"AppName": "Harmony.ipa",
				"PlistName": "Harmony.plist",
				"BucketUrl": "https://builds.myharmony.com/",
				"iOSInstallUrl": "itms-services://?action=download-manifest&url=",
				"Template": "iOS"
			},
			{
				"Name": "v5.2",
				"Header": "iOS-Harmony / v5.2",
				"Prefix": "harmony/iOS/5.2/",
				"ChangeLogUrl": "http://iosbuilds.idc.logitech.com:8080/job/Harmony-5.2/changes",
				"AppName": "Harmony.ipa",
				"PlistName": "Harmony.plist",
				"BucketUrl": "https://builds.myharmony.com/",
				"iOSInstallUrl": "itms-services://?action=download-manifest&url=",
				"Template": "iOS"
			},
			{
				"Name": "v5.1.1",
				"Header": "harmonyiOS-Harmony / v5.1.1",
				"Prefix": "harmony/iOS/5.1.1/",
				"ChangeLogUrl": "http://iosbuilds.idc.logitech.com:8080/job/Harmony-5.1.1/changes",
				"AppName": "Harmony.ipa",
				"PlistName": "Harmony.plist",
				"BucketUrl": "https://builds.myharmony.com/",
				"iOSInstallUrl": "itms-services://?action=download-manifest&url=",
				"Template": "iOS"
			},
			{
				"Name": "v5.1",
				"Header": "iOS-Harmony / v5.1",
				"Prefix": "harmony/iOS/5.1/",
				"ChangeLogUrl": "http://iosbuilds.idc.logitech.com:8080/job/Harmony-5.1/changes",
				"AppName": "Harmony.ipa",
				"PlistName": "Harmony.plist",
				"BucketUrl": "https://builds.myharmony.com/",
				"iOSInstallUrl": "itms-services://?action=download-manifest&url=",
				"Template": "iOS"
			},
			{
				"Name": "v5.0",
				"Header": "iOS-Harmony / v5.0",
				"Prefix": "harmony/iOS/5.0/",
				"ChangeLogUrl": "http://iosbuilds.idc.logitech.com:8080/job/Harmony-5.0/changes",
				"AppName": "Harmony.ipa",
				"PlistName": "Harmony.plist",
				"BucketUrl": "https://builds.myharmony.com/",
				"iOSInstallUrl": "itms-services://?action=download-manifest&url=",
				"Template": "iOS"
			},
			{
				"Name": "v4.7.3",
				"Header": "iOS-Harmony / v4.7.3",
				"Prefix": "harmony/iOS/4.7.3/",
				"ChangeLogUrl": "http://iosbuilds.idc.logitech.com:8080/job/Harmony-4.7.3/changes",
				"AppName": "Harmony.ipa",
				"PlistName": "Harmony.plist",
				"BucketUrl": "https://builds.myharmony.com/",
				"iOSInstallUrl": "itms-services://?action=download-manifest&url=",
				"Template": "iOS"
			},
			{
				"Name": "v4.7.1",
				"Header": "iOS-Harmony / v4.7.1",
				"Prefix": "harmony/iOS/4.7.1/",
				"ChangeLogUrl": "http://iosbuilds.idc.logitech.com:8080/job/Harmony-4.7/changes",
				"AppName": "Harmony.ipa",
				"PlistName": "Harmony.plist",
				"BucketUrl": "https://builds.myharmony.com/",
				"iOSInstallUrl": "itms-services://?action=download-manifest&url=",
				"Template": "iOS"
			},
			{
				"Name": "v4.7",
				"Header": "iOS-Harmony / v4.7",
				"Prefix": "harmony/iOS/4.7/",
				"ChangeLogUrl": "http://iosbuilds.idc.logitech.com:8080/job/Harmony-4.7/changes",
				"AppName": "Harmony.ipa",
				"PlistName": "Harmony.plist",
				"BucketUrl": "https://builds.myharmony.com/",
				"iOSInstallUrl": "itms-services://?action=download-manifest&url=",
				"Template": "iOS"
			},
			{
				"Name": "v4.6",
				"Header": "iOS-Harmony / v4.6",
				"Prefix": "harmony/iOS/4.6/",
				"ChangeLogUrl": "http://iosbuilds.idc.logitech.com:8080/job/Harmony-4.6/changes",
				"AppName": "Harmony.ipa",
				"PlistName": "Harmony.plist",
				"BucketUrl": "https://builds.myharmony.com/",
				"iOSInstallUrl": "itms-services://?action=download-manifest&url=",
				"Template": "iOS"
			},
			{
				"Name": "HarmonyLink",
				"Header": "iOS-HarmonyLink/ v3.0.1",
				"Prefix": "harmony/iOS/3.0.1/",
				"ChangeLogUrl": "http://iosbuilds.idc.logitech.com:8080/job/HarmonyLink1.0/changes",
				"AppName": "HarmonyLink.ipa",
				"PlistName": "Brownie.plist",
				"BucketUrl": "https://builds.myharmony.com/",
				"iOSInstallUrl": "itms-services://?action=download-manifest&url=",
				"Template": "iOS"
			}
		]
	},
	{
		"Name": "iOS - Brownie",
		"IconName": "phone_iphone",
		"IsOpen": false,
		"Branch": [
			{
				"Name": "Master",
				"Header": "iOS-Brownie/Master",
				"Prefix": "brownie/iOS/Brownie1.0/",
				"ChangeLogUrl": "http://iosbuilds.idc.logitech.com:8080/job/Brownie_master/changes",
				"AppName": "Brownie.ipa",
				"PlistName": "Brownie.plist",
				"BucketUrl": "https://builds.myharmony.com/",
				"iOSInstallUrl": "itms-services://?action=download-manifest&url=",
				"Template": "iOS"
			},
			{
				"Name": "v1.5",
				"Header": "iOS-Brownie / v1.5",
				"Prefix": "brownie/iOS/Brownie1.5/",
				"ChangeLogUrl": "http://iosbuilds.idc.logitech.com:8080/job/Brownie_1.5/changes",
				"AppName": "Brownie.ipa",
				"PlistName": "Brownie.plist",
				"BucketUrl": "https://builds.myharmony.com/",
				"iOSInstallUrl": "itms-services://?action=download-manifest&url=",
				"Template": "iOS"
			},
			{
				"Name": "v1.4",
				"Header": "iOS-Brownie / v1.4",
				"Prefix": "brownie/iOS/Brownie1.4/",
				"ChangeLogUrl": "http://iosbuilds.idc.logitech.com:8080/job/Brownie_1.4/changes",
				"AppName": "Brownie.ipa",
				"PlistName": "Brownie.plist",
				"BucketUrl": "https://builds.myharmony.com/",
				"iOSInstallUrl": "itms-services://?action=download-manifest&url=",
				"Template": "iOS"
			},
			{
				"Name": "v1.4-demo",
				"Header": "iOS-Brownie / v1.4-demo",
				"Prefix": "brownie/iOS/Brownie1.4-demo/",
				"ChangeLogUrl": "http://iosbuilds.idc.logitech.com:8080/job/Brownie_1.4-demo/changes",
				"AppName": "Brownie.ipa",
				"PlistName": "Brownie.plist",
				"BucketUrl": "https://builds.myharmony.com/",
				"iOSInstallUrl": "itms-services://?action=download-manifest&url=",
				"Template": "iOS"
			},
			{
				"Name": "v1.3",
				"Header": "iOS-Brownie / v1.3",
				"Prefix": "brownie/iOS/Brownie1.3/",
				"ChangeLogUrl": "http://iosbuilds.idc.logitech.com:8080/job/Brownie_1.3/changes",
				"AppName": "Brownie.ipa",
				"PlistName": "Brownie.plist",
				"BucketUrl": "https://builds.myharmony.com/",
				"iOSInstallUrl": "itms-services://?action=download-manifest&url=",
				"Template": "iOS"
			},
			{
				"Name": "v1.2",
				"Header": "iOS-Brownie / v1.2",
				"Prefix": "brownie/iOS/Brownie1.2/",
				"ChangeLogUrl": "http://iosbuilds.idc.logitech.com:8080/job/Brownie_1.2/changes",
				"AppName": "Brownie.ipa",
				"PlistName": "Brownie.plist",
				"BucketUrl": "https://builds.myharmony.com/",
				"iOSInstallUrl": "itms-services://?action=download-manifest&url=",
				"Template": "iOS"
			},
			{
				"Name": "v1.1",
				"Header": "iOS-Brownie / v1.1",
				"Prefix": "brownie/iOS/Brownie1.1/",
				"ChangeLogUrl": "http://iosbuilds.idc.logitech.com:8080/job/Brownie_1.1/changes",
				"AppName": "Brownie.ipa",
				"PlistName": "Brownie.plist",
				"BucketUrl": "https://builds.myharmony.com/",
				"iOSInstallUrl": "itms-services://?action=download-manifest&url=",
				"Template": "iOS"
			}
		]
	},
	{
		"Name": "Firmware - Pavarotti",
		"IconName": "device_hub",
		"IsOpen": false,
		"Branch": [
			{
				"Name": "Master",
				"Header": "Firmware-Pavarotti/Master",
				"Prefix": "Pavarotti/firmware/master/",
				"ChangeLogUrl": "http://use1afwcibuild01.idc.logitech.com:8080/job/shg-esw-pavarotti-yocto/",
				"BucketUrl": "https://builds.myharmony.com/",
				"Template": "Firmware"
			}
		]
	},
	{
		"Name": "Android - Pavarotti",
		"IconName": "android",
		"IsOpen": false,
		"Branch": [
			{
				"Name": "Master",
				"Header": "Android-Pavarotti/Master",
				"Prefix": "Pavarotti/android/master/",
				"ChangeLogUrl": "http://use1ecibuilds01.idc.logitech.com:8080/job/android-pavarotti/",
				"BucketUrl": "https://builds.myharmony.com/",
				"Template": "Android"
			}
		]
	},
	{
		"Name": "iOS - Pavarotti",
		"IconName": "phone_iphone",
		"IsOpen": false,
		"Branch": [
			{
				"Name": "Master",
				"Header": "iOS-Pavarotti/Master",
				"Prefix": "Pavarotti/ios/master/",
				"ChangeLogUrl": "http://use1ecibuilds01.idc.logitech.com:8080/job/iOS-pavarotti/",
				"PlistName": "PavarottiInHouse.plist",
				"BucketUrl": "https://builds.myharmony.com/",
				"iOSInstallUrl": "itms-services://?action=download-manifest&url=",
				"Template": "iOS"
			}
		]
	},
	{
		"Name": "MemberWeb",
		"IconName": "phone_iphone",
		"IsOpen": false,
		"Branch": [
			{
				"Name": "64BitConversion",
				"Header": "goldMW/64BitConversion",
				"Prefix": "goldMW/iOS/64BitConversion/",
				"ChangeLogUrl": "http://iosbuilds.idc.logitech.com:8080/job/Gold_MemberWeb/",
				"BucketUrl": "https://builds.myharmony.com/",
				"Template": "iOS"
			}
		]
	}
];


//////////////////
// WEBPACK FOOTER
// ./src/data/nav.json
// module id = 67
// module chunks = 0